import React, { useState } from 'react';
import { useSpring, animated } from 'react-spring';
import '../styles.css';
import { useDispatch } from 'react-redux';
import { GOTO_PAGE } from '../../HOME/REDUX/actions';
import BackButton from '../COMPONENTS/BackButton';
import { GradientBackground } from '../COMPONENTS/Background';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import _ from 'lodash';
import RobotIcon from '../COMPONENTS/RobotIcon';
import { SET_SKILL } from '../REDUX/actions';
import { PN_GREEN, PN_YELLOW, PN_RED } from '../const';
import { SIZE_PAGE } from '../../HOME/const';

const SkillPage = () => {
  const dispatch = useDispatch();
  const [skill, setSkill] = useState(0);

  const handleSkill = () => {
    dispatch({ type: SET_SKILL, skill });
    dispatch({ type: GOTO_PAGE, payload: { page: SIZE_PAGE } });
  };

  const pulseString = useSpring({
    to: { transform: `scale(${skill ? 0.75 : 1})` },
    onRest: () => {
      if (skill) {
        handleSkill();
      }
    },
    config: { duration: 200 },
  });

  return (
    <div className="page-root">
      <div className="ms-logo-title">
        <span className="pn-title">Skills</span>
      </div>
      <div className="pn-page" style={{ backgroundImage: GradientBackground }}>
        {_.map([1, 2, 3], op => {
          const style = op === skill ? pulseString : {};
          return (
            <animated.div key={op} className="pn-tile pn-option pn-skill-option" style={style} onClick={() => setSkill(op)}>
              {op === 1 ? (
                <>
                  <RobotIcon width="50px" color={PN_GREEN} style={{ gridArea: '1/1' }} />
                  <div className="pn-title pn-option-text">BASIC</div>
                </>
              ) : op === 2 ? (
                <>
                  <RobotIcon width="50px" color={PN_YELLOW} style={{ gridArea: '1/1' }} />
                  <div className="pn-title pn-option-text">MODERATE</div>
                </>
              ) : (
                <>
                  <RobotIcon width="50px" color={PN_RED} style={{ gridArea: '1/1' }} />
                  <div className="pn-title pn-option-text">ADVANCED</div>
                </>
              )}
            </animated.div>
          );
        })}
        <BackButton />
        <HomeButton />
      </div>
    </div>
  );
};

export default SkillPage;
